(function () {
  'use strict';

  var SCROLL_AMOUNT = 200;
  var TRANSITION_MS = 300;
  var sliders = document.querySelectorAll('[data-menu-slider]');

  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var prevBtn = slider.querySelector('[data-slider-prev]');
    var nextBtn = slider.querySelector('[data-slider-next]');

    if (!track || !prevBtn || !nextBtn) return;

    var offset = 0; // current shift amount (positive = shifted left)

    function getActiveList() {
      var active = track.querySelector('[data-division-menu].division-active > ul');
      if (!active) active = track.querySelector('ul');
      return active;
    }

    function getMaxOffset() {
      var list = getActiveList();
      if (!list) return 0;
      var contentWidth = list.scrollWidth;
      var trackWidth = track.clientWidth;
      return Math.max(0, contentWidth - trackWidth);
    }

    function clampOffset(val) {
      return Math.max(0, Math.min(val, getMaxOffset()));
    }

    function applyShift(animate) {
      var list = getActiveList();
      if (!list) return;
      /*
        Use margin-inline-start instead of transform to shift the menu.
        transform would create a new CSS containing block, which would
        constrain the mega-menu's width:100% to the <ul> instead of .header.
      */
      if (animate) {
        list.style.transition = 'margin-inline-start ' + TRANSITION_MS + 'ms ease';
      } else {
        list.style.transition = 'none';
      }
      list.style.marginInlineStart = offset === 0 ? '' : (-offset) + 'px';
    }

    function updateArrows() {
      var maxOff = getMaxOffset();

      if (maxOff <= 1) {
        prevBtn.classList.remove('is-visible');
        nextBtn.classList.remove('is-visible');
        return;
      }

      if (offset <= 1) {
        prevBtn.classList.remove('is-visible');
      } else {
        prevBtn.classList.add('is-visible');
      }

      if (offset >= maxOff - 1) {
        nextBtn.classList.remove('is-visible');
      } else {
        nextBtn.classList.add('is-visible');
      }
    }

    prevBtn.addEventListener('click', function () {
      offset = clampOffset(offset - SCROLL_AMOUNT);
      applyShift(true);
      updateArrows();
    });

    nextBtn.addEventListener('click', function () {
      offset = clampOffset(offset + SCROLL_AMOUNT);
      applyShift(true);
      updateArrows();
    });

    // Recalculate on resize
    var resizeObserver = new ResizeObserver(function () {
      offset = clampOffset(offset);
      applyShift(false);
      updateArrows();
    });
    resizeObserver.observe(track);

    // Watch for division-active class changes (menus toggling)
    var mutationObserver = new MutationObserver(function () {
      requestAnimationFrame(function () {
        offset = 0;
        applyShift(false);
        updateArrows();
      });
    });
    slider.querySelectorAll('[data-division-menu]').forEach(function (el) {
      mutationObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
    });

    // Initial check
    updateArrows();
  });
})();
